module.exports = __webpack_public_path__ + "name=img/src/assets/projects/design/gpm.png?5575e9f98d6e49c9a7bd30f4549ebd0f";